import React, { memo } from 'react';

// Hooks
import useWindowDimensions from 'Wpds/hooks/useWindowDimensions';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';
import WpTextField from 'Wpds/components/text-field/WpTextField';

// Styles
import './AgendaItem.scss';

type Props = {
  topic: string;
  index: number;
  handleChange: Function;
  handleRemove: Function;
};

const AgendaItem = ({ topic, index, handleChange, handleRemove }: Props) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 782;

  const handleRemoveClick = () => {
    handleRemove(index);
  };

  const handleOnChange = value => {
    handleChange(index, value);
  };
  const baseClassName = 'AgendaItem';

  return (
    <div className={baseClassName}>
      <WpIcon name="check-circle" />
      <div className={`${baseClassName}__input`}>
        <WpTextField
          id={`${index}-topic_input`}
          value={topic}
          label="Agenda Item"
          onChange={handleOnChange}
          placeholder="Add topic"
          labelHidden
          hideBorder
          autoFocus={!isMobile}
          multiline={1}
        />
      </div>
      <div className={`${baseClassName}__actions`}>
        <WpButton size="sm" variant="tertiary" onClick={handleRemoveClick}>
          <WpIcon name="times" />
        </WpButton>
      </div>
    </div>
  );
};

export default memo(AgendaItem);
